import React, { Suspense, lazy, useEffect, useState } from "react"

const SyllepsisHero = lazy(() => import("../syllepsis-hero/SyllepsisHero"))

// What every organisation knows, whatever its sector: written down and in people's heads. The hero cut shows the first five, in this order;
// the first is the hub the camera dives into. The engine expects nine.
const LABELS = ["Process maps", "Policies", "Lessons learned", "Expert know-how", "Unwritten rules",
  "Checklists", "Training manuals", "Templates", "FAQs"]

const FADE =
  "linear-gradient(to right, transparent, #000 18%, #000 82%, transparent), linear-gradient(to bottom, transparent, #000 14%, #000 86%, transparent)"

// Follows the resolved light/dark class the ThemeProvider sets on <html>, including "system".
function useResolvedTheme(): "light" | "dark" {
  const read = () => (document.documentElement.classList.contains("dark") ? "dark" : "light")
  const [theme, setTheme] = useState<"light" | "dark">(read)
  useEffect(() => {
    const observer = new MutationObserver(() => setTheme(read()))
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] })
    return () => observer.disconnect()
  }, [])
  return theme
}

export function HeroAnimation() {
  const theme = useResolvedTheme()
  // Read once at mount, like the engine's other options. The short, wide stage would otherwise show the
  // spinning graph and its labels small; phones get less of both, as their stage is narrow.
  const [size] = useState(() => (window.innerWidth < 640 ? { label: 18, zoom: 1.5, weight: 2.2 } : { label: 23, zoom: 2, weight: 2.2 }))
  return (
    // Wider than the text column so the graph has room to spread; the soft mask stops it ending in hard edges.
    <div
      className="relative shrink-0 h-[220px] sm:h-[300px] lg:h-[340px]"
      style={{ width: "min(1400px, calc(100vw - 2rem))", maskImage: FADE, WebkitMaskImage: FADE, maskComposite: "intersect", WebkitMaskComposite: "source-in" }}
    >
      <Suspense fallback={null}>
        <SyllepsisHero cut="hero" background="transparent" theme={theme} labelMinSize={size.label} graphZoom={size.zoom} graphWeight={size.weight} labels={LABELS} />
      </Suspense>
    </div>
  )
}
